import { IChangePassRequest } from "../../model/request/auth/IChangePassRequest";
import { ILoginRequest } from "../../model/request/auth/ILoginRequest";
import { ILoginVNPTRequest } from "../../model/request/auth/ILoginVNPTRequest";
import { apiClient } from "../apiClient";
import { apiGuestClient } from "../apiGuestClient";

export const authApi = {
  getUser: () => apiClient.get("account/info"),
  logIn: (request: ILoginRequest) => {
    return apiGuestClient.post(`account/login`, request);
  },

  getUserVNPT: () => apiClient.get("account/info-vnpt"),
  logInVNPT: (request: ILoginVNPTRequest) => {
    return apiGuestClient.post(`account/login-vnpt`, request);
  },

  changePassword: (request: IChangePassRequest) => {
    return apiClient.post(`account/change-password`, request);
  },
};
